import axios from 'axios';
import apiService from '@/services/apiService';
import { API_ENDPOINTS } from '@/services/config';

function normalizeCreatedResourceId(resource) {
  return resource?.id ?? resource?.data?.id ?? null;
}

export function useEntityDiscussion() {
  async function fetchComments({ entityType, entityId, entraId }) {
    const response = await axios.get(API_ENDPOINTS.associativeComments, {
      params: {
        comment_type: entityType,
        entity_id: entityId,
        entra_id: entraId,
      },
    });

    return response.data || [];
  }

  async function fetchUsers({ entraId }) {
    const response = await axios.get(API_ENDPOINTS.users, {
      params: { entra_id: entraId },
    });

    return response.data || [];
  }

  async function addComment({ entityType, entityId, text, authorId, files = [], entraId }) {
    const payload = {
      text,
      author_id: authorId,
      entity_id: entityId,
      comment_type: entityType,
    };

    const createdComment = await apiService.createResource(API_ENDPOINTS.comments, payload, entraId);
    const commentId = normalizeCreatedResourceId(createdComment);
    const normalizedFiles = Array.from(files || []);

    if (normalizedFiles.length > 0 && commentId != null) {
      await apiService.uploadFiles('comment', commentId, normalizedFiles, entraId);
    }

    return createdComment;
  }

  async function removeComment({ commentId, userId, entraId }) {
    return apiService.deleteResource(API_ENDPOINTS.comment(commentId), userId, entraId);
  }

  async function updateComment({ commentId, entityType, entityId, text, userId, entraId, authorId = userId }) {
    const payload = {
      text,
      author_id: authorId,
      entity_id: entityId,
      comment_type: entityType,
    };

    return apiService.updateResource(API_ENDPOINTS.comment(commentId), payload, userId, entraId);
  }

  return {
    fetchComments,
    fetchUsers,
    addComment,
    removeComment,
    updateComment,
  };
}
